export default __webpack_public_path__ + "images/54_2_image.jpg";